import { __decorate, __extends, __metadata } from "tslib";
import ValueObject from '../ValueObject';
import { Date as DateAttribute } from '../Decorators';
import NeoModel from '../NeoModel';
var UserEventBase = /** @class */ (function (_super) {
    __extends(UserEventBase, _super);
    function UserEventBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.by = null;
        _this.on = null;
        return _this;
    }
    Object.defineProperty(UserEventBase.prototype, "isCompleted", {
        get: function () {
            return !!this.on;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        DateAttribute(),
        __metadata("design:type", Object)
    ], UserEventBase.prototype, "on", void 0);
    return UserEventBase;
}(ValueObject));
export { UserEventBase };
var UserEvent = /** @class */ (function (_super) {
    __extends(UserEvent, _super);
    function UserEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserEvent_1 = UserEvent;
    UserEvent.None = function () {
        return new UserEvent_1();
    };
    var UserEvent_1;
    UserEvent = UserEvent_1 = __decorate([
        NeoModel
    ], UserEvent);
    return UserEvent;
}(UserEventBase));
export { UserEvent };
